import dayjs from 'dayjs';
import { keepTwoNull } from '../../utils';
import { V2MicrogridResolvedGetBsaPowerPredictPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';

export const getChartOption = (chartData?: V2MicrogridResolvedGetBsaPowerPredictPostResponse) => {
  if (chartData) {
    // 算法预测充电量
    let chargeData = (chartData?.chargePredictValues ?? []).map(item => [
      dayjs(item.timestamp).valueOf(),
      keepTwoNull(item.value),
    ]);
    // 算法预测放电量
    let dischargeData = (chartData?.disChargePredictValues ?? []).map(item => [
      dayjs(item.timestamp).valueOf(),
      keepTwoNull(item.value),
    ]);

    return {
      color: ['#57FB8B', '#00ADFF'],
      tooltip: {
        formatter: (items: any) => {
          let { axisValue } = items[0];
          let firstStr = dayjs(axisValue).format('HH:mm');
          let otherStr = '';
          items.forEach((item: any) => {
            const { seriesName, data, marker } = item;
            const unit = 'kWh';
            otherStr += `<br>${marker}${seriesName} : &nbsp;${data[1] || data[1] === 0 ? data[1] + unit : '-'}`;
          });
          return firstStr + otherStr;
        },
      },
      grid: {
        left: 60,
        right: 20,
        top: 60,
        bottom: 30,
      },
      legend: [
        {
          right: 10,
          itemGap: 18,
          itemWidth: 12,
          itemHeight: 12,
          data: [
            {
              name: '算法预测充电量',
              icon: 'rect',
            },
            {
              name: '算法预测放电量',
              icon: 'rect',
            },
          ],
        },
      ],
      xAxis: [
        {
          type: 'time',
          axisLabel: {
            textStyle: {
              color: 'rgba(255,255,255,0.85)', //坐标的字体颜色
            },
            formatter: function (e: number) {
              return dayjs(e).format('HH:mm');
            },
          },
          axisPointer: {
            type: 'shadow',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '电量（kWh）',
          nameTextStyle: {
            color: 'rgba(255,255,255,0.85)',
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: 'rgba(255,255,255,0.85)', //坐标的字体颜色
            },
          },
        },
      ],
      series: [
        {
          name: '算法预测充电量',
          type: 'bar',
          data: chargeData,
        },
        {
          name: '算法预测放电量',
          type: 'bar',
          data: dischargeData,
        },
      ],
    };
  }
};
